export const isCurrentPage = (pageNumber: number, currentPage: number): boolean => pageNumber === currentPage;
